
// Main security payloads index file that exports all security-related payloads
import { Payload } from "@/types/profile";
import { certificatePayloads } from "./certificates";
import { firewallPayloads } from "./firewall";
import { loginWindowPayloads } from "./login-window";
import { passcodePayloads } from "./passcode";
import { privacyPayloads } from "./privacy";

// Combine all security payloads
export const securityPayloads: Payload[] = [
  ...certificatePayloads,
  ...firewallPayloads,
  ...loginWindowPayloads,
  ...passcodePayloads,
  ...privacyPayloads
];
